import BackButton from "@/components/BackButton"
import type { BloodGlucoseFormContext } from "@/model/BloodGlucoseFormContext"
import cn from "@/util/cn"

const QUESTION = "What did you eat?"

type Option = {
  label: string
  value: BloodGlucoseFormContext
}

const options: Option[] = [
  { label: "Breakfast", value: "breakfast" },
  {
    label: "Snack between breakfast and lunch",
    value: "snack-between-breakfast-and-lunch",
  },
  { label: "Lunch", value: "lunch" },
  {
    label: "Snack between lunch and dinner",
    value: "snack-between-lunch-and-dinner",
  },
  { label: "Dinner", value: "dinner" },
  { label: "Snack after dinner", value: "snack-after-dinner" },
]

type Props = {
  context: BloodGlucoseFormContext | null
  onChangeMealContext: (value: BloodGlucoseFormContext) => void
  onBack?: () => void
}

const MealContextPickerStep = ({ context, onChangeMealContext, onBack }: Props) => (
  <div className="flex min-h-[calc(100vh-32px)] flex-col gap-4">
    {onBack && <BackButton customClickHandler={onBack} />}
    <h2 className="text-h2 text-primary-contrast">{QUESTION}</h2>
    <div role="radiogroup" className="mt-6 flex flex-1 flex-col justify-center gap-6">
      {options.map(({ label, value }) => {
        const selected = context === value
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChangeMealContext(value)}
            className={cn(
              "w-full rounded-xl border-4 border-primary px-8 py-5 text-h4 font-medium text-primary-contrast shadow-card transition-colors",
              selected ? "bg-primary" : "bg-white hover:bg-secondary",
            )}
          >
            {label}
          </button>
        )
      })}
    </div>
  </div>
)

export default MealContextPickerStep
